import { useQuery } from '@tanstack/react-query';
import { PortfolioApiClient } from 'api';

export const usePortfolio = (id: string) => {
  return useQuery({
    queryKey: ['portfolios', id],
    queryFn: () => PortfolioApiClient.getPortfolioById(id),
    enabled: !!id,
  });
};

export const usePortfolioArtists = (id: string) => {
  return useQuery({
    queryKey: ['portfolios', id, 'artists'],
    queryFn: () => PortfolioApiClient.getPortfolioArtists(id),
    enabled: !!id,
  });
};

export const usePortfolioHistory = (id: string) => {
  return useQuery({
    queryKey: ['portfolios', id, 'history'],
    queryFn: () => PortfolioApiClient.getPortfolioHistory(id),
    enabled: !!id,
  });
};

export const usePortfolioListings = (id: string, page = 1) => {
  return useQuery({
    queryKey: ['portfolios', id, 'listings', { page }],
    queryFn: () => PortfolioApiClient.getPortfolioListings(id, page),
    enabled: !!id,
  });
}; 
